import { render, staticRenderFns } from "./ModalChangePhone.vue?vue&type=template&id=28cea147"
import script from "./ModalChangePhone.vue?vue&type=script&lang=js"
export * from "./ModalChangePhone.vue?vue&type=script&lang=js"
import style0 from "./ModalChangePhone.vue?vue&type=style&index=0&id=28cea147&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports